import React, { Component } from 'react';

class TermsAndConditionsPage extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <div className="page tos-page">
        <div className="tos-hero">
          <div className="container">
            <p className="tos-eyebrow">Jason's Wine &amp; Spirits</p>
            <h1 className="page-title">Terms of Use</h1>
            <p className="tos-updated"><strong>Last Updated:</strong> 14 Dec 2025</p>
          </div>
        </div>

        <div className="container">
          <div className="terms-card">
            <p className="lead-text">
              These Terms of Use (“Terms”) form a binding legal agreement between you and Jason’s Wine and Spirits
              (“Jason’s,” the “Company,” “we,” “us,” or “our”). They govern your access to and use of the Site, the App,
              and related services, features, content, and functionality (collectively, the “Services”).
            </p>

            <div className="terms-section">
              <h3>1. ELIGIBILITY; AGE RESTRICTIONS</h3>
              <p>The Services are intended only for individuals who are at least 21 years old.</p>
              <p>By accessing or using the Services, you represent and warrant that:</p>
              <ul>
                <li>You are at least 21 years of age;</li>
                <li>You are legally able to enter into a binding contract; and</li>
                <li>You will not use the Services for any unlawful purpose, including the purchase or delivery of alcohol to any person under 21.</li>
              </ul>
              <p>You agree that you will not:</p>
              <ul>
                <li>Provide us with information for any person under 21;</li>
                <li>Use the Services to purchase, ship, or deliver alcohol to any person under 21; or</li>
                <li>Attempt to circumvent age-verification procedures.</li>
              </ul>
            </div>

            <div className="terms-section">
              <h3>2. THE SERVICES</h3>
              <p>The Services allow users to:</p>
              <ul>
                <li>Search for alcoholic beverages and related products;</li>
                <li>Place and schedule orders for pickup, shipment, and/or delivery (where available); and</li>
                <li>Receive information and communications regarding such orders.</li>
              </ul>
              <p>
                All orders placed through the Site or the App are accepted, reviewed, and fulfilled by Jason’s (at our licensed premises) to the extent permitted by applicable law. Each product listing is an invitation to make an offer, and not a binding offer to sell. We may accept or reject any order in our sole discretion.
              </p>
              <p>We do not intend that any part of the Services be used to facilitate:</p>
              <ul>
                <li>Improper furnishing of inducements by any alcohol manufacturer, importer, supplier, wholesaler, or distributor; or</li>
                <li>Any improper exclusionary practices by any alcohol beverage licensee.</li>
              </ul>
            </div>

            <div className="terms-section">
              <h3>3. FEES, TAXES, AND CHARGES</h3>
              <p>We do not currently charge a separate fee for access to or use of the Services. However:</p>
              <ul>
                <li>We and/or third-party service providers may charge delivery, shipping, service, or convenience fees in connection with your order;</li>
                <li>You are solely responsible for all applicable taxes, duties, and other governmental charges (including sales and use taxes); and</li>
                <li>We may, in the future, charge fees for certain Services and will notify you before such fees apply. Continued use of such Services after notice constitutes your agreement to pay applicable fees.</li>
              </ul>
              <p>All fees and charges are due immediately and will be billed to the payment method you provide.</p>
            </div>

            <div className="terms-section">
              <h3>4. ORDERING, PAYMENT, AND ACCEPTANCE</h3>
              <h4>4.1 Placing Orders</h4>
              <p>To place an order, you may be required to create an account and provide valid payment information. By submitting an order, you:</p>
              <ul>
                <li>Make an offer to purchase the products listed in your cart;</li>
                <li>Authorize us (or our payment processor) to charge your selected payment method for the full order amount, including applicable taxes and fees; and</li>
                <li>Represent that all information you provide is accurate and complete.</li>
              </ul>

              <h4>4.2 Acceptance and Fulfillment</h4>
              <p>We may accept or reject any order in our sole discretion, including, without limitation, due to:</p>
              <ul>
                <li>Product availability;</li>
                <li>Pricing or descriptive errors;</li>
                <li>Legal or regulatory restrictions; or</li>
                <li>Concerns about fraud, abuse, or misuse.</li>
              </ul>
              <p>If your order is accepted, we will process payment and prepare your order for pickup, shipping, or delivery, as you selected and as permitted by law.</p>

              <h4>4.3 Age Verification &amp; ID Requirements</h4>
              <p>For pickup, shipment, or delivery of alcoholic beverages:</p>
              <ul>
                <li>The individual receiving the order must be at least 21 years old;</li>
                <li>A valid, government-issued photo ID must be presented;</li>
                <li>The recipient may be required to sign for the order; and</li>
                <li>The person receiving the order must match the name on the order, where required by law or by our policies.</li>
              </ul>
              <p>We, our employees or agents, and any shipping or delivery partners (and their employees or agents) may refuse to complete pickup or delivery if:</p>
              <ul>
                <li>Acceptable proof of age or identity is not provided;</li>
                <li>The recipient appears intoxicated;</li>
                <li>The recipient is under 21 or we reasonably believe the alcohol will be provided to someone under 21; or</li>
                <li>Completing the transfer would otherwise be unsafe, unlawful, or inappropriate in our sole discretion.</li>
              </ul>

              <h4>4.4 Restocking Fee and Failed Deliveries</h4>
              <p>
                If your order is declined, canceled, or cannot be completed for reasons other than our out-of-stock status (or where we elect to provide a full refund), we may charge you a non-refundable restocking fee of twenty dollars ($20.00) (the “Restocking Fee”). This includes, without limitation, situations where:
              </p>
              <ul>
                <li>You or the recipient fail to provide acceptable proof of age or identity;</li>
                <li>You or the recipient are not present at the agreed delivery time and location;</li>
                <li>The recipient appears intoxicated; or</li>
                <li>The transfer is otherwise illegal, unsafe, or inappropriate in our judgment.</li>
              </ul>
              <p>If your requested items or acceptable substitutions are not in stock, we may cancel the order and issue a full refund (at our discretion) without charging the Restocking Fee.</p>
            </div>

            <div className="terms-section">
              <h3>5. SHIPPING, DELIVERY, AND TITLE</h3>
              <p>
                All sales are deemed to occur at our licensed premises. Title to, and ownership of, all products transfers from us to you at our licensed premises in California, at the time your order is processed and accepted.
              </p>
              <p>By requesting shipment or delivery, you authorize us to arrange transportation on your behalf, and such transportation may be subject to the terms and policies of our chosen carrier or delivery partner.</p>
              <p>You acknowledge and agree that:</p>
              <ul>
                <li>Certain products may not be shipped or delivered to certain states or jurisdictions due to local laws or carrier policies;</li>
                <li>You are solely responsible for complying with the laws in your jurisdiction regarding the purchase, transportation, receipt, and reporting of alcohol;</li>
                <li>You are legally entitled to take possession of the quantities ordered; and</li>
                <li>We do not guarantee any specific delivery time, and we are not responsible for delays caused by carriers, weather, or other factors outside our control.</li>
              </ul>
            </div>

            <div className="terms-section">
              <h3>6. PRICING, AVAILABILITY, AND ERRORS</h3>
              <p>
                Prices displayed on the Site or App are suggested retail prices and may not always reflect prevailing prices. We reserve the right, at any time and without notice, to:
              </p>
              <ul>
                <li>Change product prices;</li>
                <li>Correct pricing or other errors (even after an order is submitted, in which case we may cancel or adjust and notify you); and</li>
                <li>Limit quantities or discontinue products.</li>
              </ul>
            </div>

            <div className="terms-section">
              <h3>7. PROMOTIONS, DISCOUNTS, AND CREDITS</h3>
              <p>
                From time to time, we may offer promotional codes, discounts, or credits (“Promotions”). Promotions are:
              </p>
              <ul>
                <li>Non-transferable;</li>
                <li>May be subject to additional terms and conditions;</li>
                <li>May be limited to specific users, time periods, products, or locations; and</li>
                <li>May be modified or canceled by us at any time, to the maximum extent permitted by law.</li>
              </ul>
              <p>We reserve the right to refuse, suspend, or revoke any Promotion if we suspect fraud, misuse, or violation of these Terms or the applicable Promotion terms.</p>
            </div>

            <div className="terms-section">
              <h3>8. RETURNS, REFUNDS, AND ORDER ISSUES</h3>
              <p>Because alcoholic beverages are heavily regulated, returns are limited.</p>
              <ul>
                <li>Where permitted by law and our internal policies, we may accept returns or provide refunds for defective, damaged, or incorrect items.</li>
                <li>Any request for a refund or credit must usually be submitted within a reasonable time of delivery (e.g., within a few days) and include proof of purchase.</li>
                <li>We may request photos or additional information to evaluate your request.</li>
                <li>All determinations regarding returns and refunds are made by us in our sole discretion, subject to applicable law.</li>
              </ul>
            </div>

            <div className="terms-section">
              <h3>9. PRIVACY AND ACCOUNT SECURITY</h3>
              <p>
                Our Privacy Policy describes how we collect, use, and share information about you, including personal information and information related to your use of the Services. By using the Services, you consent to the practices described in the Privacy Policy.
              </p>
              <p>If you create an account:</p>
              <ul>
                <li>You must provide accurate, current, and complete information;</li>
                <li>You are responsible for maintaining the confidentiality of your login credentials; and</li>
                <li>You are responsible for all activities that occur under your account.</li>
              </ul>
              <p>
                You agree to notify us immediately of any unauthorized use of your account. We are not liable for any losses you incur due to unauthorized use of your password or account, with or without your knowledge. You may be held liable for losses incurred by us or others due to such unauthorized use.
              </p>
            </div>

            <div className="terms-section">
              <h3>10. MOBILE DEVICES AND DATA CHARGES</h3>
              <p>You are responsible for obtaining and maintaining all devices, software, internet connections, and mobile or data plans necessary to access and use the Services.</p>
              <p>We do not guarantee that the Site, the App, or the Services:</p>
              <ul>
                <li>Will be compatible with any particular device or operating system; or</li>
                <li>Will be available in any particular geographic location.</li>
              </ul>
              <p>Your carrier may charge you for data, SMS, and other usage in connection with the Services.</p>
            </div>

            <div className="terms-section">
              <h3>11. COMMUNICATIONS AND SMS CONSENT</h3>
              <p>By using the Services, you consent to receive electronic communications from us, including email, SMS/text messages, and push notifications, for:</p>
              <ul>
                <li>Transactional purposes (e.g., order confirmations, receipts, delivery updates);</li>
                <li>Operational and service-related messages; and</li>
                <li>Where legally permitted, marketing and promotional messages (if you opt in).</li>
              </ul>
              <p>If you provide a mobile phone number, you consent to receiving SMS/text messages, which may be sent using automated technology. Message and data rates may apply.</p>
              <p>You can opt out of marketing SMS messages by following the instructions in the message (e.g., replying “STOP”). You may still receive transactional or service-related messages as permitted by law.</p>
            </div>

            <div className="terms-section">
              <h3>12. SOFTWARE LICENSE AND INTELLECTUAL PROPERTY</h3>
              <p>
                Subject to your compliance with these Terms, we grant you a limited, non-exclusive, non-transferable, revocable license to access and use the Site and the App and download and use any software made available through the Services (collectively, the “Software”), solely for your personal, non-commercial use.
              </p>
              <p>We (and our licensors, as applicable) retain all right, title, and interest in and to the Site, the App, the Software, and the Services and all related content, trademarks, logos, and other intellectual property.</p>
              <p>You may not:</p>
              <ul>
                <li>Copy, modify, distribute, sell, lease, or sublicense any part of the Services or Software;</li>
                <li>Reverse engineer, decompile, or disassemble the Software, except to the limited extent expressly allowed by law; or</li>
                <li>Remove or alter any copyright, trademark, or other proprietary notices.</li>
              </ul>
            </div>

            <div className="terms-section">
              <h3>13. USER CONTENT</h3>
              <p>“User Content” means any content you submit, post, upload, share, or otherwise make available through the Services, including reviews, feedback, images, and comments.</p>
              <p>By providing User Content, you:</p>
              <ul>
                <li>Grant us and our affiliates a worldwide, non-exclusive, royalty-free, fully sublicensable, transferable license to use, reproduce, modify, adapt, publish, translate, create derivative works from, distribute, perform, and display such User Content in connection with operating, promoting, and improving the Services; and</li>
                <li>Represent and warrant that you own or have the necessary rights to grant the above license and that your User Content does not violate any third party’s rights or any law.</li>
              </ul>
              <p>
                We have no obligation to monitor or remove User Content, but we reserve the right, in our sole discretion, to remove or disable access to any User Content that we believe violates these Terms or is otherwise objectionable.
              </p>
            </div>

            <div className="terms-section">
              <h3>14. INTELLECTUAL PROPERTY COMPLIANCE (DMCA POLICY)</h3>
              <p>We respect intellectual property rights and expect our users to do the same. If you believe that any content on the Services infringes your copyright, you may send a notice to our designated agent with the following information:</p>
              <ul>
                <li>A physical or electronic signature of the copyright owner or person authorized to act on their behalf;</li>
                <li>Identification of the copyrighted work claimed to have been infringed, or a representative list of such works;</li>
                <li>Identification of the allegedly infringing material and information reasonably sufficient to permit us to locate it;</li>
                <li>Your contact information (address, phone number, and, if available, email address);</li>
                <li>A statement that you have a good faith belief that use of the material in the manner complained of is not authorized; and</li>
                <li>A statement that the information is accurate and, under penalty of perjury, that you are authorized to act on behalf of the owner.</li>
              </ul>

              <p><strong>Designated Agent for DMCA Notices:</strong></p>
              <p className="address-block">
                Jason’s Wine and Spirits<br />
                Attn: DMCA Agent<br />
                828 S. Main Street<br />
                Los Angeles, CA 90014<br />
                Email: order@jasonsliquor.com
              </p>
              <p>We may terminate the accounts of users who are repeated infringers.</p>
            </div>

            <div className="terms-section">
              <h3>15. PROHIBITED CONDUCT</h3>
              <p>You agree not to:</p>
              <ul>
                <li>Use the Services in any manner that violates any law or regulation (including alcohol and age-related laws);</li>
                <li>Attempt to gain unauthorized access to any portion of the Services or any related systems or networks;</li>
                <li>Interfere with the operation of the Services, including via malware, “flooding,” or “spamming”;</li>
                <li>Use the Services to send unsolicited advertising or promotional material;</li>
                <li>Impersonate any person or entity or misrepresent your affiliation; or</li>
                <li>Attempt to modify, reverse engineer, or otherwise tamper with any part of the Services or Software beyond what is expressly permitted.</li>
              </ul>
              <p>Any violation of system or network security may result in civil or criminal liability and may lead to immediate termination of your access to the Services.</p>
            </div>

            <div className="terms-section">
              <h3>16. THIRD-PARTY SITES AND SERVICES</h3>
              <p>The Services may contain links to, or integrate with, third-party websites, services, or content that are not owned or controlled by us. We are not responsible for:</p>
              <ul>
                <li>The content, policies, or practices of any third-party sites or services; or</li>
                <li>Any products, services, or information you obtain from such third parties.</li>
              </ul>
              <p>Your use of third-party sites or services is at your own risk and may be subject to additional terms.</p>
            </div>

            <div className="terms-section">
              <h3>17. APP STORE TERMS (APPLE AND GOOGLE)</h3>
              <h4>17.1 Apple App Store</h4>
              <p>If you download the App from the Apple App Store, you acknowledge and agree that:</p>
              <ul>
                <li>These Terms are between you and Jason’s, not Apple Inc. (“Apple”);</li>
                <li>Apple is not responsible for the App or its content;</li>
                <li>Apple has no obligation to provide any maintenance or support services for the App;</li>
                <li>In the event the App fails to conform to any applicable warranty, you may notify Apple and Apple may refund the purchase price (if any) for the App to you; and</li>
                <li>Apple is a third-party beneficiary of these Terms and may enforce them against you.</li>
              </ul>
              <p>Your use of the App must comply with the App Store Terms and Conditions.</p>

              <h4>17.2 Google Play</h4>
              <p>
                If you download the App from Google Play, your use of the App is also subject to the Google Play Terms of Service, the Google Play Business and Program Policies, and any other terms that Google designates as default end-user terms for Google Play (together, the “Google Play Terms”).
              </p>
              <p>In the event of any conflict between the Google Play Terms and these Terms, the Google Play Terms will govern your use of the App obtained via Google Play. Google is not responsible or liable for any non-compliance by you or us with these Terms or the Google Play Terms.</p>
            </div>

            <div className="terms-section">
              <h3>18. DISCLAIMER OF WARRANTIES</h3>
              <p>
                <strong>TO THE MAXIMUM EXTENT PERMITTED BY LAW, THE SITE, THE APP, THE SOFTWARE, AND THE SERVICES ARE PROVIDED ON AN “AS IS” AND “AS AVAILABLE” BASIS, WITHOUT WARRANTIES OF ANY KIND, WHETHER EXPRESS OR IMPLIED.</strong>
              </p>
              <p><strong>WITHOUT LIMITATION, WE DISCLAIM ALL IMPLIED WARRANTIES OF:</strong></p>
              <ul>
                <li>MERCHANTABILITY;</li>
                <li>FITNESS FOR A PARTICULAR PURPOSE;</li>
                <li>TITLE; AND</li>
                <li>NON-INFRINGEMENT.</li>
              </ul>
              <p>We do not warrant that:</p>
              <ul>
                <li>The Services will be uninterrupted, secure, or error-free;</li>
                <li>Any defects will be corrected; or</li>
                <li>The Services will meet your requirements or expectations.</li>
              </ul>
              <p>You use the Services at your own risk.</p>
            </div>

            <div className="terms-section">
              <h3>19. LIMITATION OF LIABILITY</h3>
              <p>
                <strong>TO THE MAXIMUM EXTENT PERMITTED BY LAW, IN NO EVENT SHALL JASON’S, ITS AFFILIATES, OR THEIR RESPECTIVE OFFICERS, DIRECTORS, EMPLOYEES, AGENTS, OR REPRESENTATIVES BE LIABLE FOR ANY:</strong>
              </p>
              <ul>
                <li><strong>INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES;</strong></li>
                <li><strong>LOSS OF PROFITS, REVENUE, OR DATA; OR</strong></li>
                <li><strong>COST OF SUBSTITUTE GOODS OR SERVICES,</strong></li>
              </ul>
              <p>
                ARISING OUT OF OR RELATED TO YOUR USE OF, OR INABILITY TO USE, THE SITE, THE APP, THE SERVICES, OR ANY PRODUCTS PURCHASED THROUGH THE SERVICES, WHETHER BASED ON WARRANTY, CONTRACT, TORT (INCLUDING NEGLIGENCE), OR ANY OTHER LEGAL THEORY, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGES.
              </p>
              <p>
                <strong>TO THE MAXIMUM EXTENT PERMITTED BY LAW, OUR TOTAL AGGREGATE LIABILITY FOR ANY CLAIMS ARISING OUT OF OR RELATING TO THE SERVICES OR THESE TERMS WILL NOT EXCEED THE AMOUNT YOU PAID TO US FOR THE TRANSACTION OR ORDER GIVING RISE TO THE CLAIM.</strong>
              </p>
              <p>Some jurisdictions do not allow certain limitations of liability, so some of the above limitations may not apply to you.</p>
            </div>

            <div className="terms-section">
              <h3>20. INDEMNIFICATION</h3>
              <p>
                You agree to indemnify, defend, and hold harmless Jason’s, its affiliates, and their respective officers, directors, employees, agents, and representatives from and against any and all claims, demands, losses, liabilities, damages, costs, and expenses (including reasonable attorneys’ fees) arising out of or related to:
              </p>
              <ul>
                <li>Your use of the Services or products purchased through the Services;</li>
                <li>Your violation of these Terms or any applicable law; or</li>
                <li>Your infringement or misappropriation of any third party’s rights.</li>
              </ul>
              <p>We reserve the right, at your expense, to assume the exclusive defense and control of any matter subject to indemnification, and you agree to cooperate with our defense.</p>
            </div>

            <div className="terms-section">
              <h3>21. GOVERNING LAW; DISPUTE RESOLUTION</h3>
              <p>These Terms and your use of the Services are governed by the laws of the State of California, without regard to conflict of laws principles.</p>
              <h4>21.1 Informal Resolution</h4>
              <p>Before filing any formal dispute, you agree to first contact us at <strong>order@jasonsliquor.com</strong> and attempt in good faith to resolve the dispute informally.</p>
              <h4>21.2 Venue</h4>
              <p>
                Subject to any arbitration or mandatory local law, you agree that any action arising out of or related to the Services or these Terms shall be brought in the state or federal courts located in Los Angeles, California, and you consent to their exclusive jurisdiction and venue.
              </p>
              <p className="highlight-note">
                ⚠️ If you want binding arbitration and/or a class action waiver, this section should be revised by an attorney to include a full arbitration clause.
              </p>
            </div>

            <div className="terms-section">
              <h3>22. EXPORT AND SANCTIONS</h3>
              <p>
                You agree to comply with all applicable U.S. export control and sanctions laws and regulations. You may not use, export, or re-export the Services or any portion thereof:
              </p>
              <ul>
                <li>To any U.S. embargoed country; or</li>
                <li>To any person on any U.S. government denied-party list.</li>
              </ul>
              <p>By using the Services, you represent and warrant that you are not located in any such country and are not on any such list.</p>
            </div>

            <div className="terms-section">
              <h3>23. TERMINATION AND SUSPENSION</h3>
              <p>
                We may, in our sole discretion and without prior notice, suspend or terminate your access to the Services (including your account) if we believe that you:
              </p>
              <ul>
                <li>Violated these Terms or applicable laws;</li>
                <li>Provided false or misleading information; or</li>
                <li>Engaged in fraudulent or abusive activity.</li>
              </ul>
              <p>
                Upon termination, your right to use the Services will immediately cease. Sections of these Terms that by their nature should survive termination (e.g., intellectual property, indemnity, limitations of liability) will continue in full force and effect.
              </p>
            </div>

            <div className="terms-section">
              <h3>24. CHANGES TO THE SERVICES AND TERMS</h3>
              <p>We may, at any time:</p>
              <ul>
                <li>Modify or discontinue any part of the Site, the App, or the Services; and/or</li>
                <li>Modify these Terms.</li>
              </ul>
              <p>
                If we make material changes to these Terms, we will post the updated Terms on the Site and update the “Last Updated” date at the top. Your continued use of the Services after the revised Terms are posted constitutes your acceptance of the changes.
              </p>
            </div>

            <div className="terms-section">
              <h3>25. SEVERABILITY; WAIVER</h3>
              <p>
                If any provision of these Terms is found to be invalid or unenforceable, that provision will be enforced to the maximum extent permissible, and the remaining provisions will remain in full force and effect.
              </p>
              <p>
                No waiver of any breach of any provision of these Terms is a waiver of any prior, concurrent, or subsequent breach, and any waiver must be in writing and signed by an authorized representative of the waiving party.
              </p>
            </div>

            <div className="terms-section">
              <h3>26. ENTIRE AGREEMENT</h3>
              <p>
                These Terms, together with our Privacy Policy and any additional terms or policies incorporated by reference, constitute the entire agreement between you and Jason’s regarding your use of the Services and supersede all prior or contemporaneous agreements related to the subject matter.
              </p>
            </div>

            <div className="terms-section">
              <h3>27. CONTACT INFORMATION</h3>
              <p>If you have any questions about the Services or these Terms, you may contact us at:</p>
              <p className="address-block">
                Jason’s Wine and Spirits<br />
                828 S. Main Street<br />
                Los Angeles, CA 90014<br />
                Email: order@jasonsliquor.com<br />
                Phone: (213) 485-9463
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default TermsAndConditionsPage;



// WEBPACK FOOTER //
// ./src/containers/tos/TermsAndConditionsPage.js